"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrintableWorksheetsState = exports["default"] = exports.SubjectCodes = exports.PRINTABLE_WORKSHEET_SCREENS = exports.Grades = exports.GradeToStringMapping = void 0;
var _react = _interopRequireWildcard(require("react"));
var _printableWorksheets = require("printableWorksheets");
var _api = require("./api");
var _common = require("apps/teacher/config/common");
var _commonDate = require("apps/teacher/config/commonDate");
var _excluded = ["userId", "worksheetsEnvironment", "onboardingGrade", "children", "subject"];
var _GradeToStringMapping;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var WS_FILTERS_LOCAL_STORAGE_KEY = "wsFilterData";
var Grades;
exports.Grades = Grades;
(function (Grades) {
  Grades["ALL_GRADES"] = "All";
  Grades["PRE_K"] = "Pre-K";
  Grades["K"] = "K";
  Grades["ONE"] = "1";
  Grades["TWO"] = "2";
  Grades["THREE"] = "3";
  Grades["FOUR"] = "4";
  Grades["FIVE"] = "5";
})(Grades || (exports.Grades = Grades = {}));
var SubjectCodes;
exports.SubjectCodes = SubjectCodes;
(function (SubjectCodes) {
  SubjectCodes["MATH"] = "math";
  SubjectCodes["ELA"] = "ela";
})(SubjectCodes || (exports.SubjectCodes = SubjectCodes = {}));
var PRINTABLE_WORKSHEET_SCREENS;
exports.PRINTABLE_WORKSHEET_SCREENS = PRINTABLE_WORKSHEET_SCREENS;
(function (PRINTABLE_WORKSHEET_SCREENS) {
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["DEFAULT"] = 0] = "DEFAULT";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["SEARCH"] = 1] = "SEARCH";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["SAVED"] = 2] = "SAVED";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["DOWNLOADED"] = 3] = "DOWNLOADED";
})(PRINTABLE_WORKSHEET_SCREENS || (exports.PRINTABLE_WORKSHEET_SCREENS = PRINTABLE_WORKSHEET_SCREENS = {}));
var GradeToStringMapping = (_GradeToStringMapping = {}, _defineProperty(_GradeToStringMapping, Grades.ALL_GRADES, 'All Grades'), _defineProperty(_GradeToStringMapping, Grades.K, 'Kindergarteners'), _defineProperty(_GradeToStringMapping, Grades.ONE, '1st Graders'), _defineProperty(_GradeToStringMapping, Grades.TWO, '2nd Graders'), _defineProperty(_GradeToStringMapping, Grades.THREE, '3rd Graders'), _defineProperty(_GradeToStringMapping, Grades.FOUR, '4th Graders'), _defineProperty(_GradeToStringMapping, Grades.FIVE, '5th Graders'), _GradeToStringMapping);
exports.GradeToStringMapping = GradeToStringMapping;
;
var PrintableWorksheetsContext = /*#__PURE__*/_react["default"].createContext({});
var PrintableWorksheetsProvider = function PrintableWorksheetsProvider(_ref) {
  var userId = _ref.userId,
    worksheetsEnvironment = _ref.worksheetsEnvironment,
    onboardingGrade = _ref.onboardingGrade,
    children = _ref.children,
    _ref$subject = _ref.subject,
    subject = _ref$subject === void 0 ? SubjectCodes.MATH : _ref$subject,
    envProps = _objectWithoutProperties(_ref, _excluded);
  var mapOnboardingGradeWithGrades = function mapOnboardingGradeWithGrades(grade) {
    var Grade = Object.keys(Grades).find(function (grade) {
      return Grades[grade] === (onboardingGrade === null || onboardingGrade === void 0 ? void 0 : onboardingGrade.toUpperCase());
    });
    return Grade ? Grades[Grade] : Grades.ALL_GRADES;
  };
  var fromOnboardingFlow = (0, _common.hasSignedUpFromWs)() && JSON.parse(localStorage.getItem("showFilteredWsData"));
  var isFromOnboardingFlow = (0, _common.isFlutterUser)() ? window.parent.parent.isFromOnboardingFlow : window.isFromOnboardingFlow;
  var activeGradeAndSubject = (0, _react.useMemo)(function () {
    var gradeToSet = null;
    var subjectToSet = null;
    // @ts-ignore
    if (fromOnboardingFlow || isFromOnboardingFlow) {
      gradeToSet = localStorage.getItem('gradeSelectedOnWs') || 'All';
      subjectToSet = (0, _common.fetchSubjectFromSignupUrl)();
    } else {
      // @ts-ignore
      if (!isFromOnboardingFlow) {
        var _localStorage;
        var filtersFromLocalStorageStr = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(WS_FILTERS_LOCAL_STORAGE_KEY);
        var filtersFromLocalStorage = JSON.parse(filtersFromLocalStorageStr || "{}");
        if (Object.keys(filtersFromLocalStorage).length > 0 && filtersFromLocalStorage.userId == userId) {
          gradeToSet = filtersFromLocalStorage.activeGrade;
          subjectToSet = filtersFromLocalStorage.subjectCode;
        } else {
          gradeToSet = mapOnboardingGradeWithGrades(onboardingGrade);
          subjectToSet = subject;
        }
      }
      if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
        gradeToSet = mapOnboardingGradeWithGrades(onboardingGrade);
        subjectToSet = subject;
      }
    }
    return {
      gradeToSet: gradeToSet,
      subjectToSet: subjectToSet
    };
  }, [fromOnboardingFlow, onboardingGrade, subject]);
  var _useState = (0, _react.useState)(activeGradeAndSubject.gradeToSet),
    _useState2 = _slicedToArray(_useState, 2),
    activeGrade = _useState2[0],
    setActiveGrade = _useState2[1];
  var _useState3 = (0, _react.useState)(activeGradeAndSubject.subjectToSet),
    _useState4 = _slicedToArray(_useState3, 2),
    subjectCode = _useState4[0],
    setSubjectCode = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    activeNode = _useState6[0],
    setActiveNode = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    activeWorksheet = _useState8[0],
    setActiveWorksheet = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    treeData = _useState10[0],
    setTreeData = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    ineligibleGrade = _useState12[0],
    setIneligibleGrade = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    viewData = _useState14[0],
    setViewData = _useState14[1];
  var _useState15 = (0, _react.useState)(''),
    _useState16 = _slicedToArray(_useState15, 2),
    worksheetSearchValue = _useState16[0],
    setWorksheetSearchValue = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    activeBreadcrumb = _useState18[0],
    setActiveBreadcrumb = _useState18[1];
  var _useState19 = (0, _react.useState)(true),
    _useState20 = _slicedToArray(_useState19, 2),
    showViewHeader = _useState20[0],
    toggleViewHeader = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showHeader = _useState22[0],
    setShowHeader = _useState22[1];
  var _useState23 = (0, _react.useState)({}),
    _useState24 = _slicedToArray(_useState23, 2),
    savedWorksheets = _useState24[0],
    setSavedWorksheets = _useState24[1];
  var _useState25 = (0, _react.useState)([]),
    _useState26 = _slicedToArray(_useState25, 2),
    savedEntityWorksheets = _useState26[0],
    setSavedEntityWorksheets = _useState26[1];
  var _useState27 = (0, _react.useState)([]),
    _useState28 = _slicedToArray(_useState27, 2),
    downloadedWorksheets = _useState28[0],
    setDownloadedWorksheets = _useState28[1];
  var _useState29 = (0, _react.useState)(null),
    _useState30 = _slicedToArray(_useState29, 2),
    searchScreenData = _useState30[0],
    setSearchScreenData = _useState30[1];
  var _useState31 = (0, _react.useState)(PRINTABLE_WORKSHEET_SCREENS.DEFAULT),
    _useState32 = _slicedToArray(_useState31, 2),
    activeScreen = _useState32[0],
    setActiveScreen = _useState32[1];
  var _useState33 = (0, _react.useState)(true),
    _useState34 = _slicedToArray(_useState33, 2),
    defaultSearch = _useState34[0],
    setDefaultSearch = _useState34[1];
  var _useState35 = (0, _react.useState)(0),
    _useState36 = _slicedToArray(_useState35, 2),
    savedCount = _useState36[0],
    setSavedCount = _useState36[1];
  var _useState37 = (0, _react.useState)(0),
    _useState38 = _slicedToArray(_useState37, 2),
    downloadCount = _useState38[0],
    setDownloadCount = _useState38[1];
  var _useState39 = (0, _react.useState)(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isWorksheetsLoading = _useState40[0],
    toggleIsWorksheetsLoading = _useState40[1];
  var _useState41 = (0, _react.useState)(''),
    _useState42 = _slicedToArray(_useState41, 2),
    filteredSearchTerm = _useState42[0],
    setFilteredSearchTerm = _useState42[1];
  var _useState43 = (0, _react.useState)({}),
    _useState44 = _slicedToArray(_useState43, 2),
    allWorksheetsScreenData = _useState44[0],
    setAllWorksheetsScreenData = _useState44[1];
  var _useState45 = (0, _react.useState)(false),
    _useState46 = _slicedToArray(_useState45, 2),
    filtersLoadedFromLocalStorage = _useState46[0],
    setFiltersLoadedLoadedFromLocalStorage = _useState46[1];
  var getSortedChildren = function getSortedChildren(children) {
    var res = children.sort(function (a, b) {
      var title1 = a.title.toLowerCase(),
        title2 = b.title.toLowerCase();
      if (title1 < title2) {
        return -1;
      }
      if (title1 > title2) {
        return 1;
      }
      return 0;
    });
    return res;
  };
  var sortChild = function sortChild(child) {
    var _child$children;
    if ((child === null || child === void 0 ? void 0 : (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.length) === 0) {
      return child;
    } else {
      child.children = getSortedChildren(child === null || child === void 0 ? void 0 : child.children);
      child.children.map(function (child) {
        return sortChild(child);
      });
      return child;
    }
  };
  var getAllSearchNodes = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(grade) {
      var isFromOnboardingFlow, paramsMath, paramsELA, promises;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isFromOnboardingFlow = (0, _common.isFlutterUser)() ? window.parent.parent.isFromOnboardingFlow : window.isFromOnboardingFlow;
            toggleIsWorksheetsLoading(function (curr) {
              return !curr;
            });
            paramsMath = {
              gradeCode: grade,
              subjectCode: SubjectCodes.MATH
            };
            paramsELA = {
              gradeCode: grade,
              subjectCode: SubjectCodes.ELA
            };
            promises = [(0, _api.fetchAllSearchNodes)(paramsMath), (0, _api.fetchAllSearchNodes)(paramsELA)];
            _context.next = 7;
            return Promise.all(promises).then(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                mathRes = _ref4[0],
                elaRes = _ref4[1];
              var sortedMathRes = sortChild(mathRes);
              var sortedElaRes = sortChild(elaRes);
              setTreeData([sortedElaRes, sortedMathRes]);
              // setActiveNode(elaRes);
              var initialElement = subject === SubjectCodes.MATH ? sortedMathRes : sortedElaRes;

              // @ts-ignore
              if (fromOnboardingFlow || isFromOnboardingFlow) {
                if ((0, _common.isFlutterUser)()) {
                  window.parent.parent.isFromOnboardingFlow = true;
                } else {
                  window.isFromOnboardingFlow = true;
                }
                var initialData = (0, _common.fetchSubjectFromSignupUrl)() === SubjectCodes.MATH ? sortedMathRes : sortedElaRes;
                var activeBreadcrumbIds = JSON.parse(localStorage.getItem("searchNodeIds"));
                var data = [initialData];
                var activeBreadcrumbData = fetchDataForActiveBreadcrumb(data, activeBreadcrumbIds, initialElement);
                setActiveBreadcrumb(activeBreadcrumbData);
                localStorage.removeItem("showFilteredWsData");
                if ((0, _common.isFlutterUser)()) {
                  window.parent.parent.isFromOnboardingFlow = false;
                } else {
                  window.isFromOnboardingFlow = false;
                }
                persistFilterData(activeBreadcrumbData);
              } else {
                // @ts-ignore
                if (!isFromOnboardingFlow && worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD) {
                  var _localStorage2;
                  var filtersFromLocalStorageStr = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(WS_FILTERS_LOCAL_STORAGE_KEY);
                  var filtersFromLocalStorage = JSON.parse(filtersFromLocalStorageStr || "{}");
                  if (Object.keys(filtersFromLocalStorage).length > 0 && !filtersLoadedFromLocalStorage && filtersFromLocalStorage.userId == userId) {
                    var _filtersFromLocalStor;
                    setActiveBreadcrumb(((_filtersFromLocalStor = filtersFromLocalStorage.activeBreadcrumb) === null || _filtersFromLocalStor === void 0 ? void 0 : _filtersFromLocalStor.length) > 0 ? filtersFromLocalStorage.activeBreadcrumb : [initialElement]);
                  } else {
                    setActiveBreadcrumb([initialElement]);
                  }
                  setFiltersLoadedLoadedFromLocalStorage(true);
                } else {
                  setActiveBreadcrumb([initialElement]);
                }
              }
            })["finally"](function () {
              return toggleIsWorksheetsLoading(function (curr) {
                return !curr;
              });
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAllSearchNodes(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var persistFilterData = function persistFilterData() {
    var _activeBreadcrumb$;
    var explicitActiveBreadCrumbData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var dataToStore = {
      userId: userId,
      activeBreadcrumb: explicitActiveBreadCrumbData ? explicitActiveBreadCrumbData : activeBreadcrumb,
      activeGrade: activeGrade,
      subjectCode: (activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.title) == 'ELA' ? SubjectCodes.ELA : SubjectCodes.MATH
    };
    localStorage.setItem(WS_FILTERS_LOCAL_STORAGE_KEY, JSON.stringify(dataToStore));
  };
  (0, _react.useEffect)(function () {
    filtersLoadedFromLocalStorage && persistFilterData();
  }, [activeBreadcrumb, activeGrade, subjectCode]);
  var getNodeContentById = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(nodeIds) {
      var params;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = {
              searchNodeIds: nodeIds,
              pageNumber: 0,
              pageSize: 10
            };
            _context2.next = 3;
            return (0, _api.fetchNodesByIds)(params).then(function (res) {
              var dataToSet = [];
              Object.keys(res.search_contents).forEach(function (nodeId) {
                var _activeNode$children;
                var worksheets = res.search_contents[nodeId];
                var match = activeNode === null || activeNode === void 0 ? void 0 : (_activeNode$children = activeNode.children) === null || _activeNode$children === void 0 ? void 0 : _activeNode$children.find(function (node) {
                  return node.id == nodeId;
                });
                var title = match ? match.section_title : "";
                var playblesCount = match ? match.playable_count : 0;
                dataToSet.push({
                  title: title,
                  nodeId: nodeId,
                  worksheets: worksheets,
                  playblesCount: playblesCount
                });
              });
              dataToSet = getSortedChildren(dataToSet);
              setViewData(dataToSet);
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getNodeContentById(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var getUserSavedCollection = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var pageNumber,
        pageSize,
        _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            pageNumber = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 0;
            pageSize = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 1000;
            if (!userId) {
              _context4.next = 5;
              break;
            }
            _context4.next = 5;
            return (0, _api.fetchSavedWorksheets)({
              userId: userId,
              pageNumber: pageNumber,
              pageSize: pageSize
            }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var result,
                data,
                tempSavedWorksheets,
                _args3 = arguments;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    result = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    data = result.user_collection_entities || [];
                    tempSavedWorksheets = data.reduce(function (acc, item) {
                      acc[item.entity_id] = item;
                      return acc;
                    }, {});
                    setSavedWorksheets(tempSavedWorksheets);
                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getUserSavedCollection() {
      return _ref6.apply(this, arguments);
    };
  }();
  var getSavedWorksheets = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var savedWorksheetIds, params, res;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            savedWorksheetIds = Object.keys(savedWorksheets);
            if (!((savedWorksheetIds === null || savedWorksheetIds === void 0 ? void 0 : savedWorksheetIds.length) > 0)) {
              _context5.next = 7;
              break;
            }
            params = {
              ids: savedWorksheetIds
            };
            _context5.next = 5;
            return (0, _api.getWorksheetsByEntityIds)({
              params: params
            });
          case 5:
            res = _context5.sent;
            setSavedEntityWorksheets(res);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getSavedWorksheets() {
      return _ref8.apply(this, arguments);
    };
  }();
  var calculateDateFromToday = function calculateDateFromToday(days) {
    return _commonDate.commonDate.CalculateDateFromToday(days);
  };
  var getDownloadedWorksheets = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(selectedDays) {
      var params, downloadedEntities, _params, res, sortedRes;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            params = _objectSpread({
              page_number: 0,
              page_size: 1000,
              created_date_sort: "desc"
            }, selectedDays !== "365" ? {
              created_date_gte: calculateDateFromToday(parseInt(selectedDays) - 1)
            } : {});
            _context6.next = 3;
            return (0, _api.getUserDownloadList)(_objectSpread(_objectSpread({}, params), {}, {
              userId: userId
            }));
          case 3:
            downloadedEntities = _context6.sent;
            if (!((downloadedEntities === null || downloadedEntities === void 0 ? void 0 : downloadedEntities.length) > 0)) {
              _context6.next = 14;
              break;
            }
            _params = {
              ids: downloadedEntities === null || downloadedEntities === void 0 ? void 0 : downloadedEntities.map(function (entity) {
                return entity.entity_id;
              })
            };
            _context6.next = 8;
            return (0, _api.getWorksheetsByEntityIds)({
              params: _params
            });
          case 8:
            res = _context6.sent;
            sortedRes = [];
            downloadedEntities.forEach(function (entity) {
              res.find(function (worksheet) {
                if ((worksheet === null || worksheet === void 0 ? void 0 : worksheet.id) === entity.entity_id) {
                  sortedRes.push(worksheet);
                }
              });
            });
            setDownloadedWorksheets(sortedRes);
            _context6.next = 15;
            break;
          case 14:
            setDownloadedWorksheets([]);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getDownloadedWorksheets(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();
  var initTeacherWorksheetsData = function initTeacherWorksheetsData() {
    getUserSavedCollection();
    getDownloadedWorksheets("7");
    (0, _api.getUserDownloadsCount)({
      userId: userId
    }).then(function (res) {
      setDownloadCount(res);
    });
    (0, _api.getUserSavedCount)({
      userId: userId
    }).then(function (res) {
      setSavedCount(res);
    });
  };
  var fetchDataForActiveBreadcrumb = function fetchDataForActiveBreadcrumb(data, ids, initialElement) {
    var result = [];
    var idsUpdated = [];
    idsUpdated = ids.length > 0 && ids.reverse();
    var recursiveFilter = function recursiveFilter(arr) {
      var _iterator = _createForOfIteratorHelper(arr),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (idsUpdated.includes(item.id)) {
            result.push(item);
          }
          if (item.children && item.children.length > 0) {
            recursiveFilter(item.children);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    if (data.length > 0 && idsUpdated.length > 0) {
      recursiveFilter(data);
    }
    return result.length > 0 ? result : [initialElement];
  };
  (0, _react.useEffect)(function () {
    var _activeNode$children2;
    if (activeNode !== null && activeNode !== void 0 && activeNode.id && (activeNode === null || activeNode === void 0 ? void 0 : (_activeNode$children2 = activeNode.children) === null || _activeNode$children2 === void 0 ? void 0 : _activeNode$children2.length) > 0) {
      getNodeContentById(activeNode === null || activeNode === void 0 ? void 0 : activeNode.children.map(function (node) {
        return node.id;
      }));
    }
  }, [activeNode === null || activeNode === void 0 ? void 0 : activeNode.id]);
  (0, _react.useEffect)(function () {
    if ((activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.length) > 0) {
      var lastBreadCrumb = activeBreadcrumb[activeBreadcrumb.length - 1];
      setActiveNode(lastBreadCrumb);
    }
  }, [activeBreadcrumb]);
  (0, _react.useEffect)(function () {
    if (activeGrade && subjectCode) {
      setTreeData([]);
      getAllSearchNodes(activeGrade);
    }
  }, [activeGrade, subjectCode]);
  (0, _react.useEffect)(function () {
    // In case ela grade change is required
    if (subject === SubjectCodes.ELA) {
      if (activeGrade > 2) {
        setIneligibleGrade(true);
      } else {
        setIneligibleGrade(false);
      }
    } else {
      setIneligibleGrade(false);
    }
    if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      setSubjectCode(subject);
    }
  }, [subject, activeGrade]);
  (0, _react.useEffect)(function () {
    worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? setActiveGrade(onboardingGrade === null || onboardingGrade === void 0 ? void 0 : onboardingGrade.toUpperCase()) : null;
  }, [onboardingGrade]);
  (0, _react.useEffect)(function () {
    worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? initTeacherWorksheetsData() : null;
  }, [userId]);
  var PrintableWorksheetsState = {
    activeGrade: activeGrade,
    activeNode: activeNode,
    activeWorksheet: activeWorksheet,
    worksheetSearchValue: worksheetSearchValue,
    subjectCode: subjectCode,
    activeBreadcrumb: activeBreadcrumb,
    showViewHeader: showViewHeader,
    userId: userId,
    worksheetsEnvironment: worksheetsEnvironment,
    treeData: treeData,
    viewData: viewData,
    onboardingGrade: onboardingGrade,
    showHeader: showHeader,
    savedWorksheets: savedWorksheets,
    savedEntityWorksheets: savedEntityWorksheets,
    downloadedWorksheets: downloadedWorksheets,
    searchScreenData: searchScreenData,
    activeScreen: activeScreen,
    defaultSearch: defaultSearch,
    savedCount: savedCount,
    downloadCount: downloadCount,
    isWorksheetsLoading: isWorksheetsLoading,
    envProps: envProps,
    ineligibleGrade: ineligibleGrade,
    filteredSearchTerm: filteredSearchTerm,
    allWorksheetsScreenData: allWorksheetsScreenData,
    setActiveGrade: setActiveGrade,
    setActiveNode: setActiveNode,
    setActiveWorksheet: setActiveWorksheet,
    setWorksheetSearchValue: setWorksheetSearchValue,
    setSubjectCode: setSubjectCode,
    setActiveBreadcrumb: setActiveBreadcrumb,
    toggleViewHeader: toggleViewHeader,
    setShowHeader: setShowHeader,
    setSavedWorksheets: setSavedWorksheets,
    getSavedWorksheets: getSavedWorksheets,
    getDownloadedWorksheets: getDownloadedWorksheets,
    setSearchScreenData: setSearchScreenData,
    setActiveScreen: setActiveScreen,
    setDefaultSearch: setDefaultSearch,
    setSavedCount: setSavedCount,
    setDownloadCount: setDownloadCount,
    setDownloadedWorksheets: setDownloadedWorksheets,
    setSavedEntityWorksheets: setSavedEntityWorksheets,
    setFilteredSearchTerm: setFilteredSearchTerm,
    setAllWorksheetsScreenData: setAllWorksheetsScreenData
  };
  return /*#__PURE__*/_react["default"].createElement(PrintableWorksheetsContext.Provider, {
    value: PrintableWorksheetsState,
    "data-sentry-element": "unknown",
    "data-sentry-component": "PrintableWorksheetsProvider",
    "data-sentry-source-file": "state.tsx"
  }, children);
};
var usePrintableWorksheetsState = function usePrintableWorksheetsState() {
  var context = (0, _react.useContext)(PrintableWorksheetsContext);
  if (!context) {
    throw Error("Use ".concat(usePrintableWorksheetsState.name, " in ").concat(PrintableWorksheetsContext.displayName));
  }
  return context;
};
exports.usePrintableWorksheetsState = usePrintableWorksheetsState;
var _default = PrintableWorksheetsProvider;
exports["default"] = _default;